module.exports = __webpack_public_path__ + "img/wtidonations.aab811cc.jpg";